export interface IAcquirerConfig {
  acquiringInstitution: string;
  forwardingInstitution: string;
  type: string;
  transactionProcessingSettings?: {
    unmatchedRefundAllowed: boolean;
    networkTokenSupported: boolean;
  };
  issuerInstalmentSettings?: {
    issuerInstalmentAllowed?: boolean;
    minimumNumberOfInstalments?: number;
    maximumNumberOfInstalments?: number;
  };
}
